"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataMeta$ = exports.DataMeta$outboundSchema = exports.DataMeta$inboundSchema = void 0;
exports.dataMetaToJSON = dataMetaToJSON;
exports.dataMetaFromJSON = dataMetaFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.DataMeta$inboundSchema = z.object({
    page: z.number().int(),
    pages: z.number().int(),
    size: z.number().int(),
    total: z.number().int(),
});
/** @internal */
exports.DataMeta$outboundSchema = z.object({
    page: z.number().int(),
    pages: z.number().int(),
    size: z.number().int(),
    total: z.number().int(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var DataMeta$;
(function (DataMeta$) {
    /** @deprecated use `DataMeta$inboundSchema` instead. */
    DataMeta$.inboundSchema = exports.DataMeta$inboundSchema;
    /** @deprecated use `DataMeta$outboundSchema` instead. */
    DataMeta$.outboundSchema = exports.DataMeta$outboundSchema;
})(DataMeta$ || (exports.DataMeta$ = DataMeta$ = {}));
function dataMetaToJSON(dataMeta) {
    return JSON.stringify(exports.DataMeta$outboundSchema.parse(dataMeta));
}
function dataMetaFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.DataMeta$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'DataMeta' from JSON`);
}
//# sourceMappingURL=datameta.js.map